"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _legendContext = _interopRequireDefault(require("../legend/_legend-context"));

var _getColorScale = _interopRequireDefault(require("../use-color-scale/_get-color-scale"));

var _theme = require("../theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * This utility takes data intended for a data visualization and a color scale
 * for the visualization and assigns colors to each data item. It also ensures
 * that each data item has a unique key (defaulting to the item's index).
 */
var useDataVisualization = function useDataVisualization(props) {
  var legend = (0, _react.useContext)(_legendContext["default"]);
  var t = (0, _theme.useTheme)();
  var colorScale = props.colorScale || (0, _getColorScale["default"])(t);
  var colorScaleIndex = 0;
  var data = (legend ? legend.data : props.data).map(function (item, index) {
    var color = item.color; // Only use the color scale (and move to the next color in the scale)
    // if the item doesn't have a color explicitly defined

    if (!color) {
      color = colorScale[colorScaleIndex % colorScale.length];
      colorScaleIndex++;
    }

    return _objectSpread({
      index: index,
      key: index,
      color: color
    }, item);
  });
  var supplementalItems = props.supplementalItems || (legend ? legend.supplementalItems : []);

  if (supplementalItems.length) {
    supplementalItems = supplementalItems.map(function (item, arrayIndex) {
      var index = arrayIndex + data.length + 1;
      var color = item.color; // Only use the color scale (and move to the next color in the scale)
      // if the item doesn't have a color explicitly defined

      if (!color) {
        color = colorScale[colorScaleIndex % colorScale.length];
        colorScaleIndex++;
      }

      return _objectSpread({
        index: index,
        key: index,
        color: color
      }, item);
    });
  }

  return {
    data: data,
    legend: legend,
    supplementalItems: supplementalItems
  };
};

var _default = useDataVisualization;
exports["default"] = _default;